// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;1,400;1,500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.split-screen-v2.split-screen-container {
  --v2-bg: #0b0b0c;
  --v2-bg-alt: #141416;
  --v2-cream: #f4efe6;
  --v2-muted: #b7b0a6;
  --v2-green: #2f6a4a;
  --v2-green-light: #6fa886;
  --v2-border: rgba(244, 239, 230, 0.12);
  --v2-error: #f08a8a;
  background: var(--v2-bg);
  color: var(--v2-cream);
  font-family: "Outfit", sans-serif;
  font-weight: 300;
}
.split-screen-v2.split-screen-container ::selection {
  background: var(--v2-green);
  color: var(--v2-cream);
}
.split-screen-v2.split-screen-container .split-screen-image {
  filter: saturate(0.9);
}
.split-screen-v2.split-screen-container .split-screen-image::before {
  background: linear-gradient(to right, rgba(11, 11, 12, 0.15) 0%, rgba(11, 11, 12, 0.35) 70%, var(--v2-bg) 100%), linear-gradient(to top, rgba(11, 11, 12, 0.55), transparent 45%);
}
.split-screen-v2.split-screen-container.content-left .split-screen-image::before {
  background: linear-gradient(to left, rgba(11, 11, 12, 0.15) 0%, rgba(11, 11, 12, 0.35) 70%, var(--v2-bg) 100%), linear-gradient(to top, rgba(11, 11, 12, 0.55), transparent 45%);
}
.split-screen-v2.split-screen-container .split-screen-content {
  background-color: var(--v2-bg) !important;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper {
  max-width: 420px;
  color: var(--v2-cream);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper img.split-screen-logo {
  height: 64px;
  margin-bottom: 48px;
}
@media (max-width: 992px) {
  .split-screen-v2.split-screen-container .split-screen-content .content-wrapper img.split-screen-logo {
    height: 48px;
    margin-bottom: 28px;
  }
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper h3.display-4 {
  font-family: "Playfair Display", serif;
  font-weight: 500;
  font-size: clamp(40px, 4vw, 56px);
  line-height: 1.05;
  letter-spacing: -0.015em;
  color: var(--v2-cream);
  margin-bottom: 16px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper h3.display-4 em {
  font-style: italic;
  color: var(--v2-green-light);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper p.muted {
  color: var(--v2-muted);
  font-size: 16px;
  line-height: 1.6;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .error-message {
  color: var(--v2-error);
  margin-top: 24px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .muted {
  color: var(--v2-muted);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .simple-link {
  color: var(--v2-green-light);
  text-underline-offset: 3px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .simple-link:hover {
  color: var(--v2-cream);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper:has(.legal-content) {
  max-width: 640px;
  align-self: flex-start;
  padding: 24px 0 48px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content {
  color: var(--v2-muted);
  font-size: 16px;
  line-height: 1.7;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content p {
  margin: 0 0 20px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content b,
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content strong {
  display: inline-block;
  margin-bottom: 4px;
  font-weight: 500;
  color: var(--v2-cream);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content ul,
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content ol {
  margin: 8px 0 0;
  padding-left: 20px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content li {
  margin-bottom: 6px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content li::marker {
  color: var(--v2-green-light);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content a {
  color: var(--v2-green-light);
  text-decoration: underline;
  text-underline-offset: 3px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper .legal-content a:hover {
  color: var(--v2-cream);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper form {
  margin-top: 36px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper form .input-container {
  margin-bottom: 16px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper form .input-container label {
  color: var(--v2-muted);
  font-size: 17px;
  left: 20px;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper form .input-container input {
  height: 60px;
  padding: 14px 20px 2px;
  font-family: "Outfit", sans-serif;
  font-size: 17px;
  color: var(--v2-cream);
  background-color: rgba(244, 239, 230, 0.04);
  border: 1px solid var(--v2-border);
  border-radius: 14px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper form .input-container input:focus {
  border: 1px solid var(--v2-green-light);
  background-color: rgba(244, 239, 230, 0.06);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper form .input-container input:-webkit-autofill {
  -webkit-text-fill-color: var(--v2-cream);
  -webkit-box-shadow: 0 0 0 1000px var(--v2-bg-alt) inset;
  caret-color: var(--v2-cream);
}
.split-screen-v2.split-screen-container .split-screen-content .content-wrapper form .input-container:focus-within label {
  color: var(--v2-green-light);
}
.split-screen-v2.split-screen-container .login-form .login-actions {
  margin-top: 28px;
  gap: 12px;
}
.split-screen-v2.split-screen-container .login-form .styled-button {
  border-radius: 999px;
  box-shadow: none;
  text-transform: none;
  letter-spacing: 0;
  font-family: "Outfit", sans-serif;
  font-weight: 500;
  font-size: 16px;
  padding: 16px 32px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}
.split-screen-v2.split-screen-container .login-form .styled-button:hover:not(:disabled) {
  transform: translateY(-1px);
}
.split-screen-v2.split-screen-container .login-form .styled-button:disabled {
  opacity: 0.55;
  cursor: default;
}
.split-screen-v2.split-screen-container .login-form .login-primary-button {
  background-color: var(--v2-green);
  color: var(--v2-cream);
}
.split-screen-v2.split-screen-container .login-form .login-primary-button:hover:not(:disabled) {
  background-color: var(--v2-green);
  color: var(--v2-cream);
  box-shadow: 0 10px 24px -8px rgba(47, 106, 74, 0.6);
}
.split-screen-v2.split-screen-container .login-form .login-primary-button:disabled {
  color: var(--v2-cream) !important;
  background-color: var(--v2-green);
}
.split-screen-v2.split-screen-container .login-form .login-google-button {
  background-color: transparent;
  color: var(--v2-cream);
  border: 1px solid rgba(244, 239, 230, 0.22);
}
.split-screen-v2.split-screen-container .login-form .login-google-button:hover:not(:disabled) {
  background-color: rgba(244, 239, 230, 0.06);
  color: var(--v2-cream);
  border-color: rgba(244, 239, 230, 0.5);
}
.split-screen-v2.split-screen-container .login-form .login-google-button:disabled {
  color: var(--v2-muted) !important;
  background-color: transparent;
  border-color: var(--v2-border);
}
.split-screen-v2.split-screen-container .login-form .login-google-wrap:hover .login-google-button:not(:disabled) {
  background-color: rgba(244, 239, 230, 0.06);
  border-color: rgba(244, 239, 230, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/styles/split-screen-v2.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,iCAAA;EACA,gBAAA;AAHF;AAKE;EACE,2BAAA;EACA,sBAAA;AAHJ;AAME;EACE,qBAAA;AAJJ;AAMI;EACE,iLACE;AALR;AAUE;EACE,gLACE;AATN;AAaE;EACE,yCAAA;AAXJ;AAaI;EACE,gBAAA;EACA,sBAAA;AAXN;AAaM;EACE,YAAA;EACA,mBAAA;AAXR;AAaQ;EAJF;IAKI,YAAA;IACA,mBAAA;EAVR;AACF;AAaM;EACE,sCAAA;EACA,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;AAXR;AAaQ;EACE,kBAAA;EACA,4BAAA;AAXV;AAeM;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AAbR;AAgBM;EACE,sBAAA;EACA,gBAAA;AAdR;AAiBM;EACE,sBAAA;AAfR;AAkBM;EACE,4BAAA;EACA,0BAAA;AAhBR;AAkBQ;EACE,sBAAA;AAhBV;AAqBM;EACE,gBAAA;EACA,sBAAA;EACA,oBAAA;AAnBR;AAsBM;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AApBR;AAsBQ;EACE,gBAAA;AApBV;AAuBQ;;EAEE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AArBV;AAwBQ;;EAEE,eAAA;EACA,kBAAA;AAtBV;AAyBQ;EACE,kBAAA;AAvBV;AAyBU;EACE,4BAAA;AAvBZ;AA2BQ;EACE,4BAAA;EACA,0BAAA;EACA,0BAAA;AAzBV;AA2BU;EACE,sBAAA;AAzBZ;AA8BM;EACE,gBAAA;AA5BR;AA8BQ;EACE,mBAAA;AA5BV;AA8BU;EACE,sBAAA;EACA,eAAA;EACA,UAAA;AA5BZ;AA+BU;EACE,YAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;EACA,sBAAA;EACA,2CAAA;EACA,kCAAA;EACA,mBAAA;EACA,8DAAA;AA7BZ;AA+BY;EACE,uCAAA;EACA,2CAAA;AA7Bd;AAiCY;EACE,wCAAA;EACA,uDAAA;EACA,4BAAA;AA/Bd;AAmCU;EACE,4BAAA;AAjCZ;AAyCI;EACE,gBAAA;EACA,SAAA;AAvCN;AA0CI;EACE,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yGAAA;AAxCN;AA0CM;EACE,2BAAA;AAxCR;AA2CM;EACE,aAAA;EACA,eAAA;AAzCR;AA6CI;EACE,iCAAA;EACA,sBAAA;AA3CN;AA6CM;EACE,iCAAA;EACA,sBAAA;EACA,mDAAA;AA3CR;AA8CM;EACE,iCAAA;EACA,iCAAA;AA5CR;AAgDI;EACE,6BAAA;EACA,sBAAA;EACA,2CAAA;AA9CN;AAgDM;EACE,2CAAA;EACA,sBAAA;EACA,sCAAA;AA9CR;AAiDM;EACE,iCAAA;EACA,6BAAA;EACA,8BAAA;AA/CR;AAoDI;EACE,2CAAA;EACA,sCAAA;AAlDN","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;1,400;1,500&display=swap');\n\n// SplitScreenLayout styled after the landing v2 palette (see pages/landing/v2/styles/landing-v2.scss).\n// Opt-in via `variant: 'v2'` in the page context, so other SplitScreenLayout pages keep their current look.\n.split-screen-v2.split-screen-container {\n  --v2-bg: #0b0b0c;\n  --v2-bg-alt: #141416;\n  --v2-cream: #f4efe6;\n  --v2-muted: #b7b0a6;\n  --v2-green: #2f6a4a;\n  --v2-green-light: #6fa886;\n  --v2-border: rgba(244, 239, 230, 0.12);\n  --v2-error: #f08a8a;\n\n  background: var(--v2-bg);\n  color: var(--v2-cream);\n  font-family: 'Outfit', sans-serif;\n  font-weight: 300;\n\n  ::selection {\n    background: var(--v2-green);\n    color: var(--v2-cream);\n  }\n\n  .split-screen-image {\n    filter: saturate(0.9);\n\n    &::before {\n      background:\n        linear-gradient(to right, rgba(11, 11, 12, 0.15) 0%, rgba(11, 11, 12, 0.35) 70%, var(--v2-bg) 100%),\n        linear-gradient(to top, rgba(11, 11, 12, 0.55), transparent 45%);\n    }\n  }\n\n  &.content-left .split-screen-image::before {\n    background:\n      linear-gradient(to left, rgba(11, 11, 12, 0.15) 0%, rgba(11, 11, 12, 0.35) 70%, var(--v2-bg) 100%),\n      linear-gradient(to top, rgba(11, 11, 12, 0.55), transparent 45%);\n  }\n\n  .split-screen-content {\n    background-color: var(--v2-bg) !important;\n\n    .content-wrapper {\n      max-width: 420px;\n      color: var(--v2-cream);\n\n      img.split-screen-logo {\n        height: 64px;\n        margin-bottom: 48px;\n\n        @media (max-width: 992px) {\n          height: 48px;\n          margin-bottom: 28px;\n        }\n      }\n\n      h3.display-4 {\n        font-family: 'Playfair Display', serif;\n        font-weight: 500;\n        font-size: clamp(40px, 4vw, 56px);\n        line-height: 1.05;\n        letter-spacing: -0.015em;\n        color: var(--v2-cream);\n        margin-bottom: 16px;\n\n        em {\n          font-style: italic;\n          color: var(--v2-green-light);\n        }\n      }\n\n      p.muted {\n        color: var(--v2-muted);\n        font-size: 16px;\n        line-height: 1.6;\n      }\n\n      .error-message {\n        color: var(--v2-error);\n        margin-top: 24px;\n      }\n\n      .muted {\n        color: var(--v2-muted);\n      }\n\n      .simple-link {\n        color: var(--v2-green-light);\n        text-underline-offset: 3px;\n\n        &:hover {\n          color: var(--v2-cream);\n        }\n      }\n\n      // Long-form pages (Privacy Policy, Terms of Use) need a wider reading column.\n      &:has(.legal-content) {\n        max-width: 640px;\n        align-self: flex-start;\n        padding: 24px 0 48px;\n      }\n\n      .legal-content {\n        color: var(--v2-muted);\n        font-size: 16px;\n        line-height: 1.7;\n\n        p {\n          margin: 0 0 20px;\n        }\n\n        b,\n        strong {\n          display: inline-block;\n          margin-bottom: 4px;\n          font-weight: 500;\n          color: var(--v2-cream);\n        }\n\n        ul,\n        ol {\n          margin: 8px 0 0;\n          padding-left: 20px;\n        }\n\n        li {\n          margin-bottom: 6px;\n\n          &::marker {\n            color: var(--v2-green-light);\n          }\n        }\n\n        a {\n          color: var(--v2-green-light);\n          text-decoration: underline;\n          text-underline-offset: 3px;\n\n          &:hover {\n            color: var(--v2-cream);\n          }\n        }\n      }\n\n      form {\n        margin-top: 36px;\n\n        .input-container {\n          margin-bottom: 16px;\n\n          label {\n            color: var(--v2-muted);\n            font-size: 17px;\n            left: 20px;\n          }\n\n          input {\n            height: 60px;\n            padding: 14px 20px 2px;\n            font-family: 'Outfit', sans-serif;\n            font-size: 17px;\n            color: var(--v2-cream);\n            background-color: rgba(244, 239, 230, 0.04);\n            border: 1px solid var(--v2-border);\n            border-radius: 14px;\n            transition: border-color 0.2s ease, background-color 0.2s ease;\n\n            &:focus {\n              border: 1px solid var(--v2-green-light);\n              background-color: rgba(244, 239, 230, 0.06);\n            }\n\n            // Keep browser autofill from painting the field light.\n            &:-webkit-autofill {\n              -webkit-text-fill-color: var(--v2-cream);\n              -webkit-box-shadow: 0 0 0 1000px var(--v2-bg-alt) inset;\n              caret-color: var(--v2-cream);\n            }\n          }\n\n          &:focus-within label {\n            color: var(--v2-green-light);\n          }\n        }\n      }\n    }\n  }\n\n  .login-form {\n    .login-actions {\n      margin-top: 28px;\n      gap: 12px;\n    }\n\n    .styled-button {\n      border-radius: 999px;\n      box-shadow: none;\n      text-transform: none;\n      letter-spacing: 0;\n      font-family: 'Outfit', sans-serif;\n      font-weight: 500;\n      font-size: 16px;\n      padding: 16px 32px;\n      transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;\n\n      &:hover:not(:disabled) {\n        transform: translateY(-1px);\n      }\n\n      &:disabled {\n        opacity: 0.55;\n        cursor: default;\n      }\n    }\n\n    .login-primary-button {\n      background-color: var(--v2-green);\n      color: var(--v2-cream);\n\n      &:hover:not(:disabled) {\n        background-color: var(--v2-green);\n        color: var(--v2-cream);\n        box-shadow: 0 10px 24px -8px rgba(47, 106, 74, 0.6);\n      }\n\n      &:disabled {\n        color: var(--v2-cream) !important;\n        background-color: var(--v2-green);\n      }\n    }\n\n    .login-google-button {\n      background-color: transparent;\n      color: var(--v2-cream);\n      border: 1px solid rgba(244, 239, 230, 0.22);\n\n      &:hover:not(:disabled) {\n        background-color: rgba(244, 239, 230, 0.06);\n        color: var(--v2-cream);\n        border-color: rgba(244, 239, 230, 0.5);\n      }\n\n      &:disabled {\n        color: var(--v2-muted) !important;\n        background-color: transparent;\n        border-color: var(--v2-border);\n      }\n    }\n\n    // The invisible Google overlay sits on top of the button, so mirror hover on the wrapper.\n    .login-google-wrap:hover .login-google-button:not(:disabled) {\n      background-color: rgba(244, 239, 230, 0.06);\n      border-color: rgba(244, 239, 230, 0.5);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
